'use strict';

var _module2 = require('./module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_module3.default.directive('localeClass', ['localizationService', function (localizationService) {
    return {
        restrict: 'AC',
        link: function link(scope, element, attrs) {
            var languageClass;
            var setLanguage = function setLanguage(language) {
                if (languageClass) {
                    attrs.$removeClass(languageClass);
                }
                languageClass = 'locale-' + language;
                attrs.$addClass(languageClass);
            };
            scope.$on('languageChanged', setLanguage);
            setLanguage(localizationService.getLanguage());
        }
    };
}]);


//////////////////
// WEBPACK FOOTER
// ./src/core/localeClass.js
// module id = 38
// module chunks = 0 2